export default "__VITE_ASSET__CnT_3yBy__"